import hexToRgba from 'hex-to-rgba';

export default class Color {

    static randomHex() {
        return Math.floor(Math.random()*16777215).toString(16);
    }

    static hexToRgba(hex, opacity) {
    	return hexToRgba(hex, opacity);
	}
}
